// extracted by mini-css-extract-plugin
export default {"button":"WhatsAppButton_button__+R9ji","icon":"WhatsAppButton_icon__MfpsC"};